// One-off Figma offsets that have no spacing token (Emerald/Home 1659:21055,
// the question modals 1552:19880 / 1552:19751 / 1552:19772, Name field
// 1796:20849). The 4/8/12/16/20/24/32 steps use --spades-spacing-*.
export const TITLE_TO_TEAM_NAMES = '19px';
export const TEAM_NAME_GAP = '6px';
export const TEAM_NAMES_TO_TABLE = '15px';
export const QUESTION_KEY_GAP = '10px';
export const QUESTION_ACTIONS_TOP = '14px';
export const HINT_PAD_Y = '3px';
